const RefillTypes = {
  REGULAR: "REGULAR",
  FIRST_FILL: "FIRST_FILL",
};

export default RefillTypes;
